import {ReactElement} from 'react';

import {getEventStatusFilterOptions} from '../../../../component/events/events-helper';
import {MainPageCardDivider} from '../../../../component/page-card-divider/main-page-card-divider';
import {getPromotionStatusFilterOptions} from '../../../../component/promotions/promotions-helper';
import {getYandexStoryStatusFilterOptions} from '../../../../component/stories/stories-helper';
import {ShortCatalogType} from '../../../../provider/catalogs/catalogs-type';
import {PublicationListFilterType} from '../../../../service/publication/publication-filter-type';
import {PostsTabEnum} from '../posts-const';
import {PostsControl} from '../posts-control/posts-control';
import {PublicationListFilter} from '../publication-list-filter/publication-list-filter';

type PropsType = {
    activeTab: PostsTabEnum;
    isLicenseExpired: boolean;
    catalogs: Array<ShortCatalogType>;
    filter: PublicationListFilterType;
    onFilterChange: (filter: PublicationListFilterType) => void;
};

export function PostsHeaderControl(props: PropsType): ReactElement | null {
    const {activeTab, isLicenseExpired, catalogs, filter, onFilterChange} = props;

    if (isLicenseExpired) {
        return null;
    }

    if (activeTab === PostsTabEnum.Posts) {
        return (
            <>
                <MainPageCardDivider />
                <PostsControl catalogs={catalogs} />
            </>
        );
    }

    if (activeTab === PostsTabEnum.Stories) {
        return (
            <>
                <MainPageCardDivider />
                <PublicationListFilter
                    filter={filter}
                    onChange={onFilterChange}
                    statusOptions={getYandexStoryStatusFilterOptions()}
                />
            </>
        );
    }

    if (activeTab === PostsTabEnum.Promotions) {
        return (
            <>
                <MainPageCardDivider />
                <PublicationListFilter
                    filter={filter}
                    onChange={onFilterChange}
                    statusOptions={getPromotionStatusFilterOptions()}
                />
            </>
        );
    }

    if (activeTab === PostsTabEnum.Events) {
        return (
            <>
                <MainPageCardDivider />
                <PublicationListFilter
                    filter={filter}
                    onChange={onFilterChange}
                    statusOptions={getEventStatusFilterOptions()}
                />
            </>
        );
    }

    return null;
}
